// extracted by mini-css-extract-plugin
module.exports = {"divider":"menuBar_divider__1f1JP","container":"menuBar_container__lDLr7"};